import React, { memo } from 'react';

import { ICarDetailsCard } from './CarDetailCard';
import FormGen from './FormGen';

const CarDetailCard = React.forwardRef((props: ICarDetailsCard.IProps, ref: any) => {
  const { title, is_guaranteed, valueMetaData, ...otherProps } = props;

  return (
    <div ref={ref}>
      <div className="tw-bg-gray800 tw-mb-4 tw-p-4 tw-rounded-lg">
        <div className="tw-flex tw-items-center tw-justify-between">
          <div className="tw-flex tw-items-center">
            <img
              alt=""
              className={`tw-mr-2 ${(!is_guaranteed && 'tw-grayscale tw-opacity-50') || ''}`}
              src="/static/svg/garanty.svg"
            />
            <h6 className="tw-text-green500 tw-font-[600]">{title}</h6>
          </div>
          <div className="tw-text-gray600">{valueMetaData}</div>
        </div>

        <FormGen {...otherProps} />
      </div>
    </div>
  );
});

// Set the display name for the component
CarDetailCard.displayName = 'CarDetailCard';

export default memo(CarDetailCard);
